import CityPageTemplate from "../city-template/CityPageTemplate";
import { royalOakConfig } from "./data";

export default function RoyalOakPage() {
  return <CityPageTemplate config={royalOakConfig} />;
}